import React from "react";
import { BPChart } from "./BPChart";
import { AppConfigurationHelper } from "../../../services/AppConfigurationHelper";
import { VitalChart } from "../../../shared/ReusableComponents/VitalChart";
import { cssVar } from "../../../theme/theme";

export const chartBandColors: any = {
  UrgentLow: "#E39191",
  Normal: "#ffffff",
  CautionHigh: "#FFEB3B77",
  CautionLow: "#FFEB3B77",
  UrgentHigh: "#D32F2F77",
  primaryLine: "#1E1E1E",
  secondaryLine: cssVar("--color-info-main"),
};

export const VitalCharts = ({ vitalData }: { vitalData: any[] }) => {
  const chartData = vitalData.map((a: any, index) => {
    return {
      Date: a.updatedOn,
      DateLabel: `O${index + 1}`,
      LowBP: a.bpLow,
      HighBP: a.bpHigh,
      pulse: a.pulse,
      respiratoryRate: a.respiratoryRate,
      oxygenSaturation: a.oxygenSaturation,
      temperature: a.temperature,
      ...AppConfigurationHelper.Instance()?.vitals,
    };
  });

  const cssStyle = {
    // height: "25rem",
    backgroundColor: "#f5f5f5",
    marginTop: "10px",
  };
  const commonProps = {
    cssStyle,
    XAxisKey: "Date",
    labelColor: "#000",
    labelFontSize: "0.8rem",
    axisFontSize: "0.8rem",
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <BPChart
        {...commonProps}
        configKey="BP"
        chartData={chartData.filter((x) => x.LowBP)}
        primaryLine={{
          dataKey: "HighBP",
          color: chartBandColors.secondaryLine,
          label: "Systolic BP",
        }}
        secondaryLine={{
          dataKey: "LowBP",
          color: chartBandColors.primaryLine,
          label: "Diastolic BP",
        }}
        YAxisLabelValue="Blood Pressure (mmHg)"
        chartTitle="Blood Pressure"
      />
      {/* pulse chart */}
      <VitalChart
        {...commonProps}
        configKey="heartRate"
        chartData={chartData.filter((x) => x.pulse === 0 || x.pulse > 0)}
        primaryLine={{
          dataKey: "pulse",
          color: chartBandColors.primaryLine,
          label: "Heart Rate (per min)",
        }}
        YAxisLabelValue="Heart Rate (per min)"
        chartTitle="Heart Rate"
      />
      {/* respiratoryRate chart */}
      <VitalChart
        {...commonProps}
        configKey="respiratoryRate"
        chartData={chartData.filter(
          (x) => x.respiratoryRate === 0 || x.respiratoryRate > 0
        )}
        primaryLine={{
          dataKey: "respiratoryRate",
          color: chartBandColors.primaryLine,
          label: "Respiratory Rate (per min)",
        }}
        YAxisLabelValue="Respiratory Rate (per min)"
        chartTitle="Respiratory Rate"
      />
      {/* oxygen chart */}
      <VitalChart
        {...commonProps}
        configKey="oxygenSaturation"
        chartData={chartData.filter((x) => x.oxygenSaturation)}
        primaryLine={{
          dataKey: "oxygenSaturation",
          color: chartBandColors.primaryLine,
          label: "Oxygen Saturation (%)",
        }}
        YAxisLabelValue="SpO2%"
        chartTitle="Oxygen Saturation"
      />
      {/* temperature chart */}
      <VitalChart
        {...commonProps}
        configKey="temperature"
        chartData={chartData.filter((x) => x.temperature)}
        primaryLine={{
          dataKey: "temperature",
          color: chartBandColors.primaryLine,
          label: `Temperature (°${
            AppConfigurationHelper.Instance()?.temperatureUnit
          })`,
        }}
        YAxisLabelValue={`Temperature (°${
          AppConfigurationHelper.Instance()?.temperatureUnit
        })`}
        chartTitle="Temperature"
      />
    </div>
  );
};

export default VitalCharts;
